<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
      >
        <el-form-item label="相关订单号" prop="order_no">
          <el-input v-model="form.order_no"/><el-button @click="OneClickFill">一键填充</el-button>
        </el-form-item>
        <el-form-item label="车辆编号" required prop="bike_no">
          <el-input v-model="form.bike_no"/>
        </el-form-item>
        <el-form-item label="用户手机号" required prop="user_mobile">
          <el-input v-model="form.user_mobile"/>
        </el-form-item>
        <el-form-item label="详情" required prop="detail">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入内容"
            v-model="form.detail"
          />
        </el-form-item>
        <el-form-item label="发生时间" required prop="occurrence_time">
          <el-date-picker
            v-model="form.occurrence_time"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item label="需支付金额" required prop="pay_money">
          <el-input-number
            v-model="form.pay_money"
            :precision="2"
            :step="0.1"
            :max="1000"
            :min="0"
          />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { editPunishmentOrder, storePunishmentOrder, updatePunishmentOrder } from '@/api/punishment_order'
import { getAreas } from '@/api/area'
import { getOrdersByNo } from '@/api/orders'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        order_no: '',
        // 'name': '',
        detail: '',
        bike_no: '',
        user_mobile: '',
        pay_money: '',
        occurrence_time: '',
      },
      errors: {},
      areas: [],
    }
  },
  methods: {
    async getData() {
      const [
        { data: areas },
      ] = await Promise.all([
        getAreas({ all: 1 }),
      ])

      this.areas = areas

      if (this.editMode) {
        const { data } = await editPunishmentOrder(this.resourceId)
        data.put_status = data.put_status ? '1' : '0'
        this.fillForm(data)
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updatePunishmentOrder(this.resourceId, this.form)
      } else {
        await storePunishmentOrder(this.form)
      }
    },
    OneClickFill() {
      // console.log(this.form.order_no)
      getOrdersByNo({ no: this.form.order_no }).then(res => {
        res.then(data => {
          // console.log(data)
          this.form.bike_no = data.data.bikes.bike_no
          this.form.user_mobile = data.data.users.mobile
        })
      })
    },
  },
}
</script>
